import { observer } from 'mobx-react'
import React, { Component } from 'react'

import Button from '../../../../UniformComponents/Button'
import Panel from '../../../../UniformComponents/Panel'
import Select from '../../../form/Select'
import TextArea from '../../../form/TextArea'

@observer
class ServiceStatusHeader extends Component {
    constructor(props) {
        super(props)
        this.intranetStore = props.intranetStore
    }

    componentDidMount() {
        const { store } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'serviceStatus',
                url: '/intranet/serviceStatus',
                title: 'Service Status',
            },
        ]
        this.intranetStore.getServiceStatus()
    }

    render() {
        const { intranetStore } = this.props
        const { serviceStatusMessage: { status, style }, options } = intranetStore

        return (
            <div>
                <div id="serviceStatus">
                    <div style={{ display: 'flex' }}>
                        <Panel>
                            <Select
                                label="Service Status CSS Class:"
                                options={options}
                                onChange={intranetStore.getServiceStatusPreviewStyle}
                                value={options.find((option) => option.value === style)}
                                className="selectStyle"
                            />

                            <br />

                            <TextArea
                                label="Service Status Message:"
                                value={status}
                                onChange={intranetStore.getServiceStatusMessage}
                                style={{ height: '300px', width: '500px' }}
                            />

                            <br />

                            <Button
                                label="Submit"
                                onClick={() => this.intranetStore.upsertServiceStatus(
                                    intranetStore.serviceStatusMessage,
                                )}
                                cssClass="regular primary"
                            />

                            {status !== ''
                                ? (
                                    <div style={{ display: 'flex' }} className={`preview ${style}`}>
                                        {status}
                                    </div>
                                )
                                : null}

                        </Panel>
                    </div>
                </div>
            </div>
        )
    }
}
export default ServiceStatusHeader
